<div class="messages" *ngIf="shouldShowChatBox">
  <div class="message-history"
       chatScroller
       scrollPerecnt="10"
       immediateCallback="true"
       [handleScrollDataCallback]="handleScrollDataCallback"
       [scrollCallback]="scrollCallback">
    <ng-template ngFor [ngForOf]="messageList" let-mess>
      <div class="message invitation" *ngIf="isCampaignMessage(mess) && showActivityLog">
        <div class="msg-content">
          <div class="msg-content-left">
            <p>{{mess.content}}</p>
            <div class="details">{{mess.activityAuthor}} - {{ mess.sentTime | date: 'dd MMM yyyy - hh:mm' }}</div>
          </div>
          <div class="msg-link" *ngIf="!isContactPermissionMessage(mess) && !isLandingPageMode">
            <a (click)="openCampaignDetails(mess.campaignId, mess.campaignInfluencerId, mess.status)">{{'inbox.view_invite' | translate}} ></a>
          </div>
        </div>
        <div class="datetime" [ngClass]="{'opacity-none': !showActivityLog}">
          <span>{{ mess.sentTime | date: 'dd MMM yyyy - hh:mm' }}</span>
          <span class="camp-status">{{ getCampaignMessageStatus(mess) }}</span>
        </div>
      </div>
      <div class="message incomming"  *ngIf="isIncommingMessage(mess)">
        <div class="received-msg">
          <p>{{mess.content}}</p>
          <div class="details">
            <img class="icon" src="{{getSenderAvatar(mess)}}" onerror="this.src='assets/images/email_circle.svg'" >
            <div class="datetime">{{getSenderName(mess)}}
              <span [ngClass]="{'opacity-none': !showActivityLog}">{{ mess.sentTime | date: 'dd MMM yyyy - hh:mm' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="message outgoing" *ngIf="isOutgoingMessage(mess)">
        <div class="sent-msg">
          <p>{{mess.content}}</p>
          <div class="details">
            <div class="message-loader" *ngIf="mess.isSending">
              <achoo-loader [normalPlaceholder]="true"></achoo-loader>
            </div>
            <div class="datetime" *ngIf="!mess.isSending && !isError">
              {{getSenderName(mess)}}
              <span [ngClass]="{'opacity-none': !showActivityLog}">{{ mess.sentTime | date: 'dd MMM yyyy - hh:mm' }}</span>
              <img class="icon" src="{{getSenderAvatar(mess)}}" onerror="this.src='assets/images/email_circle.svg'" >
            </div>
            <div class="message-error" *ngIf="isError && mess.id === 0">
              <div class="message-error-icon"></div>
              {{'inbox.not_sent' | translate}}
              <a (click)="retryOnError(mess)">{{'inbox.try_again' | translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="type-message">
    <div class="msg-actions">
      <span>{{'inbox.show_activity_log' | translate}}</span>
      <achoo-toggle-switch [(model)]="showActivityLog" (switchChange)="onShowActivityLogChange($event)"></achoo-toggle-switch>
    </div>
    <div class="d-flex message-input" *ngIf="canSendMessage(conversation)">
      <input placeholder="{{'inbox.writing_a_message' | translate}}" [attr.disabled]="conversation.isHidden ? 'disabled' : null" [(ngModel)]="inputMessageContent" (keydown)="onKeyDown($event)">
      <button *ngIf="canSendMessage(conversation)"
              type="button" class="button blue"
              [ngClass]="{'show': isShowSendButton()}"
              [disabled]="isMessageTooLong"
              (click)="onSendMessage()">
        {{'inbox.send' | translate}}
      </button>
    </div>
    <div class="d-flex need-permission" *ngIf="needPermission(conversation)">
      <span class="error">{{getPermissionMessage(conversation)}}</span>
      <button *ngIf="isNotRequestPermission(conversation)"
              type="button" class="button blue"
              (click)="sendPermissionRequest(conversation)">{{'inbox.send_permission_request' | translate}}
      </button>
      <button *ngIf="isRequestedPermission(conversation)"
              type="button" class="button gray">
        {{'inbox.permission_requested' | translate}}
      </button>
    </div>
    <div class="d-flex justify-content-end flex-g1 warning-message">
      <span *ngIf="isMessageTooLong">{{'inbox.message_too_long' | translate:{message_length: numberCharacterOver(inputMessageContent)} }}</span>
    </div>
  </div>
</div>
<achoo-popup #AlertMessageTooLong
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span class="no-wrap-text">{{'inbox.message_too_long' | translate:{message_length: numberCharacterOver(inputMessageContent)} }}</span>
</achoo-popup>

<achoo-popup #ServerErrorNotification
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{serverErrorMessage}}</span>
</achoo-popup>
<achoo-popup #adminEditConversationAlert
             [modelTitle]="'contact_permission.admin_alert' | translate"
             [acceptBtnLabel]="'common.btn.close' | translate"
             (cancelCallback)="closePopup()"
             (acceptCallback)="closePopup()">
  <span>{{'contact_permission.admin_alert_message' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/influencer-chat/influencer-chat.component.html